"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validator_1 = require("./validator");
exports.default = validator_1.validatorMiddleware;
